import config from 'config';
import View from 'lib/View';

import tmpl from './locate.phtml';
import Map from 'view/map';
import Form from './form';

export default View.extend({
	template: tmpl,

	events: {
	},




	initialize: function()
	{
		this.map = new Map();
		this.form = new Form({
			model: this.model,
		});

		this.geolocation = app.getStore('geolocation');
		this.settings = app.getStore('settings');

		this.listenToOnce( this.map, 'render', this.initializeMap );
	},


	initializeMap: function( map )
	{
		var latlng = this.map.marker.getLatLng();
		this.marker = L.marker( latlng, { draggable: true, autoPan: true, zIndexOffset: 1000 } ).addTo( this.map.map );

		this.onReset( latlng );

		// Déplacement du curseur met à jour la mare et le texte
		this.listenTo( this.map, 'reset', this.onReset );
		this.listenTo( this.map, 'click', this.onClick );
		this.listenTo( this.marker, 'drag', this.onDrag );
		this.listenTo( this.marker, 'move', this.onMove );
		this.listenTo( this.geolocation, 'latlng', this.onLatLng );
	},



	// Suivre la géolocalisation tant qu'on a pas déplacé la mare
	onLatLng: function()
	{
		if( !this.dragged )
		{
			this.onReset();
		}
	},

	// On recentre la carte et la mare sur notre position
	onReset: function()
	{
		var latlng = this.geolocation.isLocated() ? this.geolocation.getLatLng() : this.settings.getLatLng();

		this.marker.setLatLng( latlng );
		this.map.setPositionText( latlng );
		this.dragged = false;

		this.onMove( latlng );
	},

	// On position la mare sur une position
	onClick: function( evt )
	{
		var latlng = evt.latlng || evt;

		this.marker.setLatLng( latlng );
		this.onDrag( latlng );
	},

	// On déplace la mare
	onDrag: function( evt )
	{
		var latlng = evt.latlng || evt;

		this.map.setPositionText( latlng );
		this.dragged = true;
		this.onMove( latlng );
	},

	// On enregistre la nouvelle position de la mare
	onMove: _.debounce( function( evt )
	{
		var latlng = evt.latlng || evt;

		this.model.set( latlng );
		this.map.setPositionText( latlng );
		this.form.setLatLng( latlng );
	}, 100 ),




	render: function()
	{
		this.doRender({
			pond: this.model,
		});

		this.map.setElement('#map');
		this.map.render({
			draggable: true,
			label: 'Position de la mare :'
		});

		this.form.setElement('#form');
		this.form.render();
	},

	unload: function()
	{
		this.map.unload();
		this.map.remove();

		this.form.unload();
		this.form.remove();

		this.doUnload();
	}

});
